import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import emailConfirmationIcon from '../../assets/images/icons/email-confirmation.svg';
import StatusView from '../../components/StatusView/StatusView';

class UserVerified extends React.Component {
  static propTypes = {
    authUser: PropTypes.object,
  };

  static defaultProps = {
    authUser: {},
  };

  render() {
    const term = this.props.authUser.isLoaded ? 'event listing' : 'sign in page';
    const buttonText = `Go to ${term}`;
    const loadingText = `Redirecting to ${term}...`;

    return (
      <StatusView
        buttonText={buttonText}
        image={emailConfirmationIcon}
        loadingText={loadingText}
        navigationPath={this.destination}
        title="Email successfully confirmed!"
      />
    );
  }

  get destination() {
    return this.props.authUser.isLoaded ? '/' : '/auth';
  }
}

export default connect(
  state => ({
    authUser: state.firebase.auth,
  })
)(UserVerified);



// WEBPACK FOOTER //
// ./src/views/UserVerified/UserVerified.js